function display_error_msg({ target, msg = get_language_translation('REQUIRED_FIELD_LANG'), custom_section = false, ...options }){
	// Target - id/class of the input that requires a value,
	// msg - is the error message to display, 
	// custom_section is an object with the following structure: { section_type: 'unique-conditional-identifier', subsection: '.target-class' }

	let skipInputError = false;
	var $el = am.$(target);
	var time_tracking_id_arr = ['track_date', 'employee', 'contact_id', 'track_order', 'track_order_id', 'order_status', 'process', 'processModal', 'track_hours'];

	if($el.hasClass('js-validate-cc-number') || $el.hasClass('js-default-address') || $el.hasClass('js-address-country') || $el.hasClass('am_state_dropdown') || $el.attr('id').includes('bank_name')){
		var $row = $el.parent().closest('.am-section-row');
	}else if($el.hasClass('js-cc_exp_year') || $el.hasClass('js-cc_exp_month')){
		skipInputError = true;
		var $row = $el.parent().closest('.am-section-row');
	}
	else if($el.hasClass('js-address-state')){
		var $row = $el.parent().closest('.address-state');
	}
	else if($el.attr('id') == 'password')
		var $row = $el.parent().parent().closest('.am-section-row');
	else if($el.hasClass('am-textarea'))
		var $row = $el.parent().closest('.am-textarea-row');
	else if(time_tracking_id_arr.includes($el.attr('id'))){
		var $row = $el.parent().closest('.input');
	}
	else{
		var $row = $el.parent('.am-section-row');
		if ($row.length == 0) 
			var $row = $el.parent().closest('.am-section-row--select');
	}

	if($row.length == 0 && $el.parent().hasClass('am-section-input--indecator')) // handles input rows with indecator style 
		var $row = $el.parent('.am-section-input--indecator').parent('.am-section-row').closest('.am-section-row');

	if ($row.length == 0)
		var $row = $el.closest('.am-section-row');

	if ($row.length == 0) {
		var $row = this.getRowIfEmpty($el);
	}

    var $label = $row.children('.am-section-label');
	if($label.length == 0 && $row.hasClass('am-section-row--select')){
		var $label = $row.children('span').children('.am-section-label');
	}
	if($label.length == 0)
		var $label = $row.find('.am-section-label');
	var $err_msg = $row.children('.error-msg');

	if($el.hasClass('js-default-address'))
		$err_msg = $row.children('.am-default-adress-cont')

	if(options.err){
		if(options.err.border)
			$el.addClass('am-error-border');

		if(options.err.text)
			$label.addClass('am-error-text');
	}else{
		if(!skipInputError)
			$el.addClass('am-error-border');

		$label.addClass('am-error-text');
	}

	if(custom_section){
		if(custom_section == 'am-exp-date-cont'){
			const $section = am.$('#'+custom_section);
			$section.addClass('am-error-border')
			var $elms = $section.find('input');
			var error_lable_id = 'am-exp-date-cont-err-label';

			$elms.on('blur', (e) => {
				remove_error_classes($label, $section, target);
				am.$('#am-exp-date-cont-err-label').remove();
			});
		}
		else if(custom_section == 'track_order' || custom_section == 'order_status'){
			const $input = $row.find('#'+custom_section);
			var error_lable_id = custom_section+'_err_label';

			$input.on('click', (e) => {
				remove_error_classes($label, $input, custom_section);
				am.$('#'+error_lable_id).remove();
			});
		}
		else if(custom_section == 'process' || custom_section == 'processModal'){
			const $select = am.$('#'+custom_section).siblings('.select2');
			$select.addClass('am-error-border');
			var error_lable_id = custom_section+'_err_label';

			$select.on('click', (e) => {
				am.$('#'+error_lable_id).remove();
			});
		}
	}
	else{
		var error_lable_id = remove_escape_brackets(`${target.replace('#', '')}_err_label`);

		var onEvent = 'blur';
		if(options.clearOnKeyDown)
			onEvent = 'keydown';
		else if(options.clearOnClick)
			onEvent = 'click';

		$el.on(onEvent, () => remove_error_classes($label, $el, target));
	}

	if(am.$('#undefined.error-msg').length > 0){ // failsafe for undefined error message getting stuck on the page
		am.$('#undefined.error-msg').remove();
	}

	if(options.set_focus)
		$el.focus();

	const $section = $row.parent().closest('.am-section-section');
	if($section.length > 0 && $section.attr('data-status') == 'closed' && !$section.hasClass('background-hint--error'))
		$section.siblings('.accordian').addClass('background-hint--error'); // Used to show errors hidden within closed sections

	var hidden_msg = options.err && options.err.hide_msg ? ' error-msg--hidden ' : '';

	if($err_msg.length == 0)
		$row.append(`<label id="${error_lable_id}" class="error-msg ${hidden_msg}"><i class="fas fa-exclamation-triangle" style="margin-right: 5px;"></i><span class="msg">${msg}</span></label>`);
	else if(msg != $err_msg.children('.msg').text())
		$err_msg.children('.msg').text(msg);
}


function display_error_msg_datatable_row({ target, msg = get_language_translation('REQUIRED_FIELD_LANG'), custom_section = false, ...options }){
	// Target - id/class of the input that requires a value, 
	// msg - is the error message to display

	const $el = am.$(target);
	var $td = $el.parent('td');
	$td.addClass('show-error')

	const $err_msg = $td.children('.error-msg');
	$el.addClass('am-error-border')

	var error_lable_id = `${target.replace('#', '')}_err_label`;
	$el.on('blur', () => {
		$td.removeClass('am-error-text show-error');
		$el.removeClass('am-error-border');
		am.$(target+'_err_label').remove();
	});

	if(options.set_focus)
		$el.focus();

	var textAlign = 'error-msg--start';
	if($td.hasClass('js-err-end'))
		textAlign = 'error-msg--end';

	else if($td.hasClass('js-err-start'))
		textAlign = 'text-left';
	else
		textAlign = 'text-center';

	
	if($err_msg.length == 0)
		$td.append(`<label id="${error_lable_id}" class="error-msg ${textAlign}"><i class="fas fa-exclamation-triangle" style="margin-right: 5px;"></i><span class="msg">${msg}</span></label>`);
	else if(msg != $err_msg.children('.msg').text())
		$err_msg.children('.msg').text(msg);
}

function process_phone_validations(mox){ // This will be removed when edit comp, comp/individual contact(s) page has been rebuilt with new UI
	var phones = document.querySelectorAll('.js-phone-number');
	if(phones.length > 0){
		phones.forEach((el, i) => {
			var valid = (el.value.match(/^(\s*[\+]?\s*1\s*[\.-]?)?\s*(\d{3}|\(\s*\d{3}\s*\))\s*[\.-]?\s*\d{3}\s*[\.-]?\s*\d{4}((\s|[\.-]){1}\s*[\.-]?\s*([extnsioEXTENSIO\.\:]{1,9}?\s*[\.-]?)?\d{1,7})?$/))
			mox.validate(valid, el, get_language_translation('LANG_LABEL_PHONE_NUMBER_INVALID'));
			const parent = el.up('.phone-element-wrapper');
			if(parent){
				const type = parent.querySelector('.base_type_class');
				if(type)
					mox.require(type, get_language_translation('LANG_TYPE_IS_REQUIRED'));
	
				const extension = parent.querySelector('.base_extension_class')
				if(!extension || extension.value != '')
					mox.validate((extension.value.match(/^\d{4}$/)), extension, get_language_translation('LANG_LABEL_INVALID_EXTENSION'));
			}
		})
	}
}

function remove_error_classes($label, $el, target){
	$label.removeClass('am-error-text');
	$el.removeClass('am-error-border');

	if(target.charAt(0) !== '#')
		target = '#' + target;
	
	am.$(target+'_err_label').remove();
	// This resets tethered inputs js-required class per each submit event
	if($el.hasClass('js-required_from_tether')) {
			$el.removeClass('js-required js-required_from_tether');
	}
}